<template>
    <rkm-overlay>
        <rkm-layout-body title="Configuração do sistema">
            <template v-slot:actions>                
                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>
        
            <rkm-layout-content>
                <Form ref="Form" />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/administracao/configuracao/Form'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { Form },
    created() {
        this.setShowExitFormConfirmation()
    },
    methods: {
        ...mapActions(['setShowExitFormConfirmation']),
    },
}
</script>